import { getSpeakerColor } from '@/utils/speaker-colors'
import { formatElapsedTime } from '@/utils/formatElapsedTime'

interface SpeakerLabelProps {
  speakerNumber: string | number
  speakerName?: string
  /** Milliseconds elapsed since recording start when this turn began — renders an `mm:ss` marker next to the label. Omit to hide it. */
  timestampMs?: number
}

export default function SpeakerLabel({ speakerNumber, speakerName, timestampMs }: SpeakerLabelProps) {
  const speakerColor = getSpeakerColor(speakerNumber)
  const label = speakerName?.trim() || `Speaker ${speakerNumber}`
  return (
    <div className="mt-2 flex items-baseline gap-5 text-sm font-bold uppercase" style={{ color: speakerColor }}>
      {label}:
      {timestampMs !== undefined && (
        <time className="text-xs font-normal normal-case tabular-nums text-slate-500 dark:text-[var(--text-tertiary)]">
          {formatElapsedTime(timestampMs)}
        </time>
      )}
    </div>
  )
}
